<template>
	<div class="loading">
		<div class="item" v-if="isLoading && isNoData">加载中...</div>
		<div class="item" v-if="!isNoData">我们也是有底线的~</div>
	</div>
</template>

<script>
	export default{
		name: 'LoadingMore',
		props: {
			isLoading: {
				type: Boolean,
				required: true
			},
			distance: {
				type: Number,
				default: 50
			},
			isNoData: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				el: null
			}
		},
		mounted: function(){
			window.addEventListener('scroll', this.listenerClick)
			this.el = document.documentElement
		},
		destroyed: function(){
			window.removeEventListener('scroll', this.listenerClick, false)
		},
		methods: {
			listenerClick: function(){
				if(!this.isNoData || this.isLoading) return
				let scTop = this.el.scrollTop || document.body.scrollTop
				let clHeight = this.el.clientHeight
				let scHeight = this.el.scrollHeight
				if (scTop + clHeight >= scHeight - this.distance){
					this.$emit('doLoading')
				}
			}
		}
	}
</script>

<style scoped>
.loading{ display: flex; justify-content: center; align-items: center; height: 40px; line-height: 40px; font-size: 16px; color: rgba(0, 0, 0, 0.4); font-size: 14px;}
.loading>.item{ background: rgba(0, 0, 0, 0.04); padding: 0 10px;}
</style>
